import {combineReducers} from 'redux'
import userLoginReducer from './userLogin.reducer'
import facturacionReducer from './facturacion.reducer'
import historialReducer from './historial.reducer'
import generalReducer from './general.reducer'
import creacionUsuarioReducer from './creacionUsuario.reducer'
import catalogoReducer from './catalogos.reducer'
import olvidoPassReducer from './flujoOlvidoPass.reducer'
import documentosReducer from './documentos.reducer'
import gestionUsuarioReducer from './gestionUsuario.reducer'
import gestionProductoReducer from './gestionProducto.reducer'
import productosReducer from './productos.reducer'
import exportacionReducer from './dte-exportacion.reducer'
import sujetoExcluidoReducer from './sujetoExcluido.reducer'
import suspcripcionReducer from './suscripcion.reducer'
import creditoFiscalReducer from './credito-fiscal.reducer'
import notaRemisionReducer from './nota-remision.reducer'
import notaCreditoReducer from './nota-credito.reducer'
import notaDebitoReducer from './nota-debito.reducer'
import notaDebitoExternoReducer from './nota-debito-externo.reducer'
import facturaExportacionReducer from './factura-exportacion.reducer'
import comprobanteRetencionReducer from './comprobanteRetencion.reducer'
import formaPagoReducer from './forma-pago.reducer'
import comprobanteLiquidacionReducer from './comprobante-liquidacion.reducer'
import documentoLiquidacionReducer from './documento-liquidacion.reducer'
import notaCreditoExternoReducer from './nota-credito-externo.reducer'
import horarioReducer from './horario.reducer'
import librosReducer from './libros.reducer'
import bitacoraReducer from './bitacora.reducer'

const rootReducer = combineReducers({
  userLogin: userLoginReducer,
  facturacion: facturacionReducer,
  documentos: documentosReducer,
  historial: historialReducer,
  general: generalReducer,
  creacionUsuario: creacionUsuarioReducer,
  catalogos: catalogoReducer,
  olvidoPass: olvidoPassReducer,
  gestionUsuario: gestionUsuarioReducer,
  gestionProducto:gestionProductoReducer,
  productos:productosReducer,
  sujetoExcluido: sujetoExcluidoReducer,
  exportacion: exportacionReducer,
  suscripcion: suspcripcionReducer,
  creditoFiscal: creditoFiscalReducer,
  notaRemision: notaRemisionReducer,
  notaCredito: notaCreditoReducer,
  notaCreditoExterno: notaCreditoExternoReducer,
  notaDebito: notaDebitoReducer,
  notaDebitoExterno: notaDebitoExternoReducer,
  facturaExportacion: facturaExportacionReducer,
  comprobanteRetencion: comprobanteRetencionReducer,
  formaPago: formaPagoReducer,
  comprobanteLiquidacion: comprobanteLiquidacionReducer,
  documentoLiquidadcion: documentoLiquidacionReducer,
  horarios: horarioReducer,
  libros: librosReducer,
  bitacora: bitacoraReducer,
})

export default rootReducer
export type State = ReturnType<typeof rootReducer>
